angular
    .module('vm.config', [])
    .constant('CONFIG', {
        project: 'rmb',
        projectName: 'RichMeetBeautiful',
        premiumIconColor: 'white',

        defaultDomainSettings: {},
        
        oAuthDefaultRedirectUrl: 'https://m.stage.vm.digisec.info/oauth.html',
        oAuthProviders: {
            facebook: {
                appScope: ['public_profile', 'email', 'user_photos', 'user_birthday', 'user_gender']
            },
            instagram: {
                appScope: ['public_content']
            },
            windowsLive: {
                appScope: ['wl.basic']
            },
            google: {
                appScope: ['email', 'profile']
            }
        },

        // 'ALL' for all domains
        smsVerificationDomains: [],

        profileSections: [
            {
              name: 'appearance',
              translationKey: 'profile.appearance.label',
              icon: 'eye',
              fields: [
                {
                  name: 'height',
                  labelTranslationKey: 'profile.appearance.height'
                },
                {
                  name: 'weight',
                  labelTranslationKey: 'profile.appearance.weight'
                },
                {
                  name: 'eyes',
                  labelTranslationKey: 'profile.appearance.eyes'
                },
                {
                  name: 'hair',
                  labelTranslationKey: 'profile.appearance.hair'
                },
                {
                  name: 'body_type',
                  labelTranslationKey: 'profile.appearance.body_type'
                },
                {
                  name: 'looks',
                  labelTranslationKey: 'profile.appearance.looks'
                },
                {
                  name: 'ethnicity',
                  labelTranslationKey: 'profile.appearance.ethnicity'
                },
                {
                  name: 'best_feature',
                  labelTranslationKey: 'profile.appearance.best_feature'
                },
                {
                  name: 'piercing',
                  labelTranslationKey: 'profile.appearance.piercing'
                },
                {
                  name: 'tattoo',
                  labelTranslationKey: 'profile.appearance.tattoo'
                },
                {
                  name: 'facial_hair',
                  labelTranslationKey: 'profile.appearance.facial_hair'
                }
              ]
            },
            {
              name: 'background_and_lifestyle',
              translationKey: 'profile.background_and_lifestyle',
              icon: 'information-circled',
              fields: [
                {
                  name: 'relationship_status',
                  labelTranslationKey: 'profile.my_details.relationship_status'
                },
                {
                  name: 'smoking',
                  labelTranslationKey: 'profile.my_details.smoking'
                },
                {
                  name: 'drinking',
                  labelTranslationKey: 'profile.my_details.drinking'
                },
                {
                  name: 'exercise_habits',
                  labelTranslationKey: 'profile.my_details.exercise_habits',
                  enumTranslationKey: 'enumexercisehabits'
                },
                {
                  name: 'occupation',
                  labelTranslationKey: 'profile.my_details.occupation'
                },
                {
                  name: 'education',
                  labelTranslationKey: 'profile.my_details.education'
                },
                {
                  name: 'diet1',
                  labelTranslationKey: 'profile.my_details.diet1'
                },
                {
                  name: 'has_secret_love_nest',
                  labelTranslationKey: 'profile.my_details.has_secret_love_nest'
                },
                {
                  name: 'sex_drive',
                  labelTranslationKey: 'profile.my_details.sex_drive'
                },
                {
                  name: 'orientation',
                  labelTranslationKey: 'profile.my_details.orientation'
                },
                {
                  name: 'languages',
                  labelTranslationKey: 'profile.my_details.languages',
                  multipleUi: true,
                },
              ]
            },
            {
              name: 'personality',
              translationKey: 'profile.details.personality',
              icon: 'na',
              fields: [
                {
                  name: 'interest',
                  labelTranslationKey: 'profile.my_details.interest',
                  multipleUi: true,
                },
                {
                  name: 'personality',
                  labelTranslationKey: 'profile.my_details.personality',
                  multipleUi: true,
                },
                {
                  name: 'turns_on',
                  labelTranslationKey: 'profile.my_details.turns_on',
                  multipleUi: true,
                  enumTranslationKey: 'enumturnson',
                }
              ]
            },
            {
              name: 'seeking',
              translationKey: 'search.seeking_for_title',
              icon: 'na',
              fields: [
                {
                  name: 'seeking_location',
                  labelTranslationKey: 'profile.my_details.seeking_location'
                },
                {
                  name: 'seeking_sex',
                  labelTranslationKey: 'profile.my_details.seeking_sex'
                },
                {
                  name: 'best_match_orientation',
                  labelTranslationKey: 'profile.my_details.seeking_orientation',
                  multipleUi: false,
                  multipleBackend: true,
                  enumTranslationKey: 'enumorientation',
                },
                {
                  name: 'seeking_type_of_relationship',
                  labelTranslationKey: 'profile.my_details.seeking_type_of_relationship',
                  multipleUi: true,
                  enumTranslationKey: 'enumseekingtypeofrelationship',
                }
              ]
            },
        ],
    })
;